var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "#EA5504"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8298 6.94393L8.6778 12.8375C8.62421 12.889 8.56054 12.9299 8.49044 12.9578C8.42033 12.9856 8.34517 13 8.26926 13C8.19335 13 8.11819 12.9856 8.04809 12.9578C7.97798 12.9299 7.91431 12.889 7.86073 12.8375L5.16922 10.2591C5.11557 10.2077 5.07301 10.1466 5.04398 10.0795C5.01494 10.0123 5 9.94037 5 9.86769C5 9.795 5.01494 9.72303 5.04398 9.65588C5.07301 9.58873 5.11557 9.52771 5.16922 9.47632C5.22287 9.42492 5.28656 9.38415 5.35666 9.35634C5.42675 9.32852 5.50188 9.31421 5.57775 9.31421C5.65362 9.31421 5.72875 9.32852 5.79885 9.35634C5.86895 9.38415 5.93264 9.42492 5.98629 9.47632L8.26974 11.6638L14.0137 6.16211C14.1221 6.05831 14.269 6 14.4222 6C14.5755 6 14.7224 6.05831 14.8308 6.16211C14.9391 6.26591 15 6.40669 15 6.55348C15 6.70027 14.9391 6.84105 14.8308 6.94485L14.8298 6.94393Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOn);
export default __webpack_public_path__ + "static/media/icon_check_on.df69ab6cd82fc4ed5d9b214714b523c2.svg";
export { ForwardRef as ReactComponent };